import { Star } from "lucide-react";

const testimonials = [
  {
    name: "Akua M.",
    role: "Salon owner, Accra",
    quote: "I was losing walk-ins because I couldn't take card. Now I create a booking, give them the code, and they pay the rest online. Game changer.",
    stars: 5,
  },
  {
    name: "Kofi A.",
    role: "Barber, Kumasi",
    quote: "No-shows used to kill my days. With reminders and the booking link, my chair stays full. Clients actually show up.",
    stars: 5,
  },
  {
    name: "Abena S.",
    role: "Spa owner, Tema",
    quote: "I used to run everything from WhatsApp and a notebook. One calendar, one place for payments — I finally have control.",
    stars: 5,
  },
  {
    name: "Yaw K.",
    role: "Gym owner, East Legon",
    quote: "Member check-ins used to be a mess. Now we scan at the door, sell day passes, and everything's logged. So much smoother.",
    stars: 5,
  },
  {
    name: "Ama D.",
    role: "Food vendor, Osu",
    quote: "Orders were getting lost in chats. Now I have one orders page, company links for offices, and I know exactly what to prep.",
    stars: 5,
  },
  {
    name: "Kwame B.",
    role: "Clinic admin, Labone",
    quote: "Patients used to forget appointments. SMS reminders and the pay-remaining link mean fewer no-shows and less chasing payments.",
    stars: 5,
  },
  {
    name: "Efua T.",
    role: "Studio owner, Cantonments",
    quote: "I needed one link for booking and one for payments. Buukd does both. My clients love how simple it is.",
    stars: 5,
  },
];

function GoldStars({ count }: { count: number }) {
  return (
    <div className="flex gap-0.5" aria-label={`${count} out of 5 stars`}>
      {Array.from({ length: count }).map((_, i) => (
        <Star
          key={i}
          className="h-4 w-4 fill-[#EAB308] text-[#EAB308] shrink-0"
          aria-hidden
        />
      ))}
    </div>
  );
}

function TestimonialCard({
  name,
  role,
  quote,
  stars,
}: (typeof testimonials)[0]) {
  return (
    <div
      className="flex-shrink-0 w-[320px] sm:w-[380px] bg-card rounded-xl border border-border p-5 shadow-soft hover:shadow-soft-md transition-shadow"
      style={{ scrollSnapAlign: "start" }}
    >
      <GoldStars count={stars} />
      <p className="mt-3 text-sm text-foreground leading-relaxed">&ldquo;{quote}&rdquo;</p>
      <div className="mt-4">
        <p className="text-sm font-semibold text-foreground">{name}</p>
        <p className="text-xs text-muted-foreground">{role}</p>
      </div>
    </div>
  );
}

export function ReviewsMarquee() {
  const duplicated = [...testimonials, ...testimonials];

  return (
    <div className="relative overflow-hidden marquee-pause">
      <div className="marquee-inner flex gap-6 w-max py-2">
        {duplicated.map((t, i) => (
          <TestimonialCard key={`${t.name}-${i}`} {...t} />
        ))}
      </div>
    </div>
  );
}
